import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { IonicSlides, ModalController, Platform } from '@ionic/angular';

import { ZoomableImageComponent } from '../zoomable-image/zoomable-image.component';

@Component({
  selector: 'itl-lightbox',
  templateUrl: './lightbox.modal.html',
  styleUrls: ['./lightbox.modal.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class LightboxModal implements OnInit {
  @ViewChild('slides', { static: true }) slides: ElementRef | undefined;
  @ViewChildren(ZoomableImageComponent) zoomables?: QueryList<ZoomableImageComponent>;

  @Input()
  public images = [];
  @Input()
  public currentIndex = 0;
  public isAndroid: boolean;
  public version: number;
  public swiperModules = [IonicSlides];

  public get isIos() {
    return this._platform.is('ios');
  }

  constructor(
    public _modalCtrl: ModalController,
    private _platform: Platform
  ) {}

  async ngOnInit() {
    await this.slides?.nativeElement.swiper.update();
    await this.slides?.nativeElement.swiper.slideTo(this.currentIndex);
  }

  public async slideChanged() {
    const swiper = this.slides?.nativeElement?.swiper;
    const currentIndex = swiper?.activeIndex;
    if (currentIndex < this.images.length) {
      this.currentIndex = currentIndex;
    }
    // Reset every slide's zoom so users don't return to a still-zoomed image,
    // and re-enable swiping in case a previous slide had locked it.
    this.zoomables?.forEach(z => z.reset());
    if (swiper) {
      swiper.allowTouchMove = true;
    }
  }

  /**
   * Locks/unlocks the swiper's touch swipe based on the active image's zoom.
   * Without this, panning a zoomed image would also slide between images.
   */
  public onZoomChange(zoom: number): void {
    const swiper = this.slides?.nativeElement?.swiper;
    if (!swiper) return;
    swiper.allowTouchMove = zoom <= 1.001;
  }
}
